import React, {Component} from 'react';

export default class SwitcherBox extends Component{
        render(){
            return(
                <li className="switcher-box">
                    <label className="switch" htmlFor={'btn'+this.props.name}>
                        {this.props.text}
                        <input 
                            id={'btn'+this.props.name}
                            type="checkbox" name={'btn'+this.props.name} value="auto" 
                            checked={this.props.checked} 
                            onChange={() => this.props.onChange()} 
                        />
                        <div className="switch-btn"></div>
                    </label>
                </li>
            );
        }
}


// WEBPACK FOOTER //
// ./src/js/studio/ui/switcherBox.js